import {
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'
import { InputCurrencyMask } from '../../components/input-numbers'


const SectionDelivery = ({ mall }) => {
  const defaultValues = {
    delivery_name: mall?.delivery_name,
    track_url: mall?.track_url,
    delivery_guide: mall?.delivery_guide,
    min_order: mall?.min_order,
    delivery_cost: mall?.delivery_cost
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm()

  useEffect(() => {    
    reset(defaultValues)
  }, [mall])

  const onSubmit = async (data, e) => {
    const params = JSON.stringify({
      "delivery_name": data.delivery_name,
      "track_url": data.track_url,
      "delivery_guide": data.delivery_guide,
      "min_order": data.min_order,
      "delivery_cost": data.delivery_cost
    });

    try {
      await apiService.put('/malls/delivery', params);
      toast.success('업데이트 되었습니다.');
    } catch (error) {
      console.error(error);
    }
  }

  return (
    mall &&
    <Card>
      <CardHeader title='배송 정보' titleTypographyProps={{ variant: 'h6' }} />
      <CardContent>
        <form onSubmit={handleSubmit(onSubmit)} id="malldeliveryform">
          <Grid container spacing={6}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id='delivery_name'>배송업체</InputLabel>
                <Controller
                  name='delivery_name'
                  control={control}
                  rules={{ required: true }}
                  renderValue={selected => (selected.length === 0 ? '' : selected)}
                  render={({ field: { value, onChange } }) => (
                    <Select
                      label='배송업체'
                      value={value || ''}
                      onChange={onChange}
                      labelId='delivery_name'
                      error={Boolean(errors.delivery_name)}
                      variant="standard"
                    >
                      <MenuItem value="경동택배">경동택배</MenuItem>
                      <MenuItem value="대신택배">대신택배</MenuItem>
                      <MenuItem value="동부택배">동부택배</MenuItem>
                      <MenuItem value="로젠택배">로젠택배</MenuItem>
                      <MenuItem value="우체국">우체국</MenuItem>
                      <MenuItem value="이노지스택배">이노지스택배</MenuItem>
                      <MenuItem value="한진택배">한진택배</MenuItem>
                      <MenuItem value="롯데택배">롯데택배</MenuItem>
                      <MenuItem value="CJ대한통운">CJ대한통운</MenuItem>
                      <MenuItem value="KG옐로우캡택배">KG옐로우캡택배</MenuItem>
                      <MenuItem value="KGB택배">KGB택배</MenuItem>
                      <MenuItem value="KG로지스">KG로지스</MenuItem>
                      <MenuItem value="건영택배">건영택배</MenuItem>
                      <MenuItem value="호남택배">호남택배</MenuItem>
                    </Select>
                  )}
                />
                {errors.delivery_name && (
                  <FormHelperText sx={{ color: 'error.main' }} id='validation-async-delivery_name'>
                    필수
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Controller
                  name='track_url'
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { value, onChange } }) => (
                    <TextField
                      value={value || ''}
                      label='배송조회 URL'
                      id='track_url'
                      onChange={onChange}
                      placeholder='배송조회 URL을 입력해주세요'
                      error={Boolean(errors.track_url)}
                      aria-describedby='validation-async-track_url'
                      variant="standard"
                    />
                  )}
                />
                {errors.track_url && (
                  <FormHelperText sx={{ color: 'error.main' }} id='validation-async-track_url'>
                    필수
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id='min_order'>무료배송 최소금액</InputLabel>
                <Controller
                  name='min_order'
                  control={control}
                  rules={{ required: true }}
                  defaultValue='10000'
                  render={({ field: { value, onChange } }) => (
                    <InputCurrencyMask
                      value={value || ''}
                      label='무료배송 최소금액'
                      id='min_order'
                      onChange={onChange}
                      placeholder='무료배송 결제 최소금액 입력해주세요'
                      error={Boolean(errors.min_order)}
                      aria-describedby='validation-async-min_order'
                    />
                  )}
                />
                {errors.min_order && (
                  <FormHelperText sx={{ color: 'error.main' }} id='validation-async-min_order'>
                    필수
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id='delivery_cost'>배송비</InputLabel>
                <Controller
                  name='delivery_cost'
                  control={control}
                  rules={{ required: true }}
                  defaultValue='0'
                  render={({ field: { value, onChange } }) => (
                    <InputCurrencyMask
                      value={value || ''}
                      label='배송비'
                      id='delivery_cost'
                      onChange={onChange}
                      placeholder='배송비를 입력해주세요'
                      error={Boolean(errors.delivery_cost)}
                      aria-describedby='validation-async-delivery_cost'
                    />
                  )}
                />
                {errors.delivery_cost && (
                  <FormHelperText sx={{ color: 'error.main' }} id='validation-async-delivery_cost'>
                    필수
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <Controller
                  name='delivery_guide'
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { value, onChange } }) => (
                    <TextField
                      value={value || ''}
                      label='배송/교환/반품안내'
                      rows={4}
                      multiline
                      id='delivery_guide'
                      onChange={onChange}
                      placeholder='내용을 입력해주세요'
                      error={Boolean(errors.delivery_guide)}
                      aria-describedby='validation-async-delivery_guide'
                    />
                  )}
                />
                {errors.delivery_guide && (
                  <FormHelperText sx={{ color: 'error.main' }} id='validation-async-delivery_guide'>
                    필수
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>


            <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(7)} !important` }}>
              <Button type="submit" form="malldeliveryform" variant='contained' sx={{ mr: 4 }}>
                수정
              </Button>
            </Grid>

          </Grid>
        </form>
      </CardContent>
    </Card>
  )
}

export default SectionDelivery
